/* eslint-disable*/
import { ArrowBack } from "@mui/icons-material";
import { PageNavigation } from "../Headers/PageNavigation";
import { useHistory } from "react-router-dom";
import { urls } from "@/Constants";

function QcLogsHeader(props) {
    const { navigateQC, idx, listData, id } = props;
    const history = useHistory();
    
    const handleBack = () => {
            history.push(`${urls.EXTENSION}${urls.QUALITY_LOGS}${history?.location?.state?.search ?? ''}`);
    }

    return (
        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 fixed left-0 right-0 top-16 bg-white z-[999] shadow-sm h-[3.5rem]">
            <div className="flex items-center gap-2 relative left-[16rem]">
                <ArrowBack onClick={handleBack} className="cursor-pointer" />
                <p className="text-base font-medium">Back to GRN Qc Logs</p>
            </div>
            <div>
                <PageNavigation
                    navigate={navigateQC}
                    prev={{
                        tooltip: 'Previous Batch',
                        show: idx > 0,
                        disabled: idx === 0,
                    }}
                    current={{
                        label: 'QC ID',
                        value: id,
                    }}
                    next={{
                        tooltip: 'Next Batch',
                        show: idx >= 0 && idx < listData.length - 1,
                        disabled: idx < 0 || idx === listData.length - 1,
                    }}
                />
            </div>
        </div>
    );
}

export default QcLogsHeader;


